import { useIsMobile } from 'hooks/ui/useIsMobile';
import React, { ReactNode } from 'react';

export const PaymentLayout = ({
  OrderSumaryComponent,
  PaymentComponent,
}: {
  OrderSumaryComponent: ReactNode;
  PaymentComponent: ReactNode;
}) => {
  const { isMobile } = useIsMobile(1000) // Check if the screen width is >= 1024px

  return (
    <div>
      <style>{`
        .wrapper {
          width: 100%;
          min-width: ${!isMobile ? '1000px' : 'none'};
          max-width: 1200px;
          display: grid;
          grid-template-columns: 1fr 1fr;
          grid-template-areas: ${
            !isMobile
              ? `
            'flow-content order-summary'
            'flow-content order-summary'
          `
              : `
            'order-summary order-summary'
            'flow-content flow-content'
          `
          };
          gap: 4%;
        }
        
        .flow-content {
          width: 100%;
          grid-area: flow-content;
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        
        .order-summary {
          width: 100%;
          grid-area: order-summary;
          display: flex;
          align-items: start;
        }

        @media (min-width: 1000px) {
          .flow-content {
            min-width: 450px;
          }
        }
      `}</style>
      <div className="wrapper">
        <div className="flow-content">{PaymentComponent}</div>
        <div className="order-summary">{OrderSumaryComponent}</div>
      </div>
    </div>
  );
};
